(function() {
    var selectors = {
        contentVideo: '.section-faq-video .section-faq-video__content',
        playVideo: '.section-faq-video .section-faq-video__content a.btn--play',
        iframeVideo: '.section-faq-video .section-faq-video__content__iframe',
        iframeVideoIframe: '.section-faq-video .section-faq-video__content__iframe iframe',
        closeVideo: '.section-faq-video .section-faq-video__content__iframe .head__close'
    };

    var contentVideo = document.querySelector(selectors.contentVideo);
    var playVideo = document.querySelector(selectors.playVideo);
    var iframeVideo = document.querySelector(selectors.iframeVideo);
    var iframeVideoIframe = document.querySelector(selectors.iframeVideoIframe);
    var closeVideo = document.querySelector(selectors.closeVideo);

    if (contentVideo) {
        playVideo.addEventListener("click", function(){
            contentVideo.classList.add('hide')
            iframeVideo.classList.remove('hide')
            closeVideo.classList.remove('hide')
            iframeVideoIframe.src += "?autoplay=1";
        });
        closeVideo.addEventListener("click", function(){
            iframeVideoIframe.src = iframeVideoIframe.src.replace('?autoplay=1','');;
            contentVideo.classList.remove('hide')
            closeVideo.classList.add('hide')
            iframeVideo.classList.add('hide')
        });
    }
  
})();
  